import React, { useContext } from 'react'

import { AppContext } from 'providers/context/App'
import { ReactComponent as MapPinIcon } from '../../../assets/icons/map-pin-1-new.svg'

import './locationFacialBar.scss'

interface LocationFacialBarProps {
  showServiceName?: boolean
}

const LocationFacialBar: React.FC<LocationFacialBarProps> = ({
  showServiceName = false,
}) => {
  const { appMasterData } = useContext(AppContext)
  const { location, selectedFacial } = appMasterData

  if (!location?.name) return null

  return (
    <div className="location-facial-bar">
      {showServiceName && selectedFacial && (
        <p className="location-facial-bar-service">{selectedFacial} at</p>
      )}
      <div className="location-facial-bar-location">
        <MapPinIcon className="location-facial-bar-pin" />
        <span className="location-facial-bar-name">{location.name}</span>
      </div>
    </div>
  )
}

export default React.memo(LocationFacialBar)
